import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/import',
      method: 'post',
      data: data
    })
  },

  getCecItemAgileField: function (params) {
    return request({
      url: '/cecitemagilefield/cecItemAgileField/getCecItemAgileField',
      method: 'post',
      params: params
    })
  }
}
